import { Button } from 'react-bootstrap'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '../../../../components/icons/DeleteIcon'
import { ConsignmentItem } from '../models/types'

type TransitConsignmentItemsTableActionsProps = {
  selectedCount: number
  rows: ConsignmentItem[]
  onClearSelection: () => void
  onDeleteSelected: () => void
  isBulkDeleteNotAllowed: boolean
  isBulkDeleting: boolean
}

function ConsignmentItemsTableActions({
  selectedCount,
  rows,
  onClearSelection,
  onDeleteSelected,
  isBulkDeleteNotAllowed,
  isBulkDeleting,
}: TransitConsignmentItemsTableActionsProps) {
  const { t } = useTranslation()

  return (
    <div className="bulk-actions">
      <span className="bulk-actions__count">
        {t('table.rowsSelected', { selectedCount, total: rows.length })}
      </span>
      <div className="bulk-actions__buttons">
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={onClearSelection}
        >
          {t('common.clear')}
        </button>
        <Button
          variant="danger"
          size="sm"
          className="text-uppercase"
          onClick={onDeleteSelected}
          disabled={isBulkDeleteNotAllowed}
        >
          <DeleteIcon className="me-1" />
          {isBulkDeleting && <span className="spinner-border spinner-border-sm me-1" />}
          {t('table.deleteSelected')}
        </Button>
      </div>
    </div>
  )
}

export default ConsignmentItemsTableActions
